import PropTypes from 'prop-types';

const usefulStatValuePropType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);

export const UsefulStatsPropTypes = PropTypes.shape({
  stat1: PropTypes.shape({
    stat: PropTypes.string.isRequired,
    value: usefulStatValuePropType.isRequired,
    color: PropTypes.string,
  }).isRequired,
  stat2: PropTypes.shape({
    stat: PropTypes.string.isRequired,
    value: usefulStatValuePropType.isRequired,
    color: PropTypes.string,
  }).isRequired,
  stat3: PropTypes.shape({
    stat: PropTypes.string.isRequired,
    value: usefulStatValuePropType.isRequired,
    color: PropTypes.string,
  }),
});

export const ConnectionsQualityPropTypes = PropTypes.arrayOf(PropTypes.shape({
  connectionName: PropTypes.string.isRequired,
  connectionErpName: PropTypes.string.isRequired,
  readyToTax: PropTypes.number.isRequired,
  successComplete: PropTypes.number.isRequired,
  successPercent: PropTypes.number.isRequired,
}));

export const BusinessesQualityPropTypes = PropTypes.arrayOf(PropTypes.shape({
  businessCode: PropTypes.string.isRequired,
  businessDescription: PropTypes.string.isRequired,
  readyToTax: PropTypes.number.isRequired,
  successComplete: PropTypes.number.isRequired,
  successPercent: PropTypes.number.isRequired,
}));

